// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calendar {\n  box-sizing: border-box;\n  font-size: 1rem;\n  max-width: 100%;\n  position: relative; }\n", ""]);
// Exports
module.exports = exports;
